<template>
  <div class="topic-bar" @click="topicClick">
    <userInfoBar :user-name="fuserName" :topic-time="fanswerTime"></userInfoBar>
    <div class="topic-title">
      {{ftopicName}}
    </div>
    <div class="topic-summary">
      {{fsummaryInfo}}
    </div>
    <div class="topic-content">
      <markdownCode :txt="fanswerContext"></markdownCode>
    </div>
    <div class="topic-foot">
      <img src="../../assets/icon-like.svg"/>
      <span>{{flikeCount}}</span>
      <img src="../../assets/icon-reply.svg"/>
      <span>{{freplyCount}}</span>
    </div>
  </div>
</template>

<script>
import userInfoBar from "@/components/panel/userInfoBar";
import markdownCode from "@/components/common/markdownCode";

export default {
  name: "topicRow",
  props:{
    topicInfo: {
      type: Object,
      default: () =>{
        return{
          topicId: "id",
          topicName: "小程序",
          answerTime: "2023-12-12",
          answerContext: "答案分享内容",
          likeCount: 10,
          replyCount:110,
          viewCount: 200,
          author:{
            authorId: "作者ID",
            authorName: "作者名称",
            authorIcon: "undefined"
          },
          summaryInfo: "附加信息"
        }
      }
    }
  },
  computed:{
    fimgSrc:function (){
      if (this.topicInfo.author.authorIcon == undefined){
        return '/static/image/head.png';
      }else {
        return this.topicInfo.author.authorIcon;
      }
    },
    fuserName:function (){
      return this.topicInfo.author.authorName;
    },
    fanswerTime: function (){
      return this.topicInfo.answerTime;
    },
    flikeCount: function (){
      if (this.topicInfo.likeCount == 0){
        return ''
      }else{
        return this.topicInfo.likeCount
      }
    },
    freplyCount: function (){
      if (this.topicInfo.replyCount == 0){
        return ''
      }else{
        return this.topicInfo.replyCount;
      }
    },
    ftopicName: function(){
      return this.topicInfo.topicName;
    },
    fanswerContext: function (){
      return decodeURI(this.topicInfo.answerContext) ;
    },
    fsummaryInfo: function (){
      return this.topicInfo.summaryInfo;
    }
  },
  methods:{
    topicClick:function (){
      this.$emit("event-topic-click", this.topicInfo)
    }
  },
  components:{
    userInfoBar,
    markdownCode
  }
}
</script>

<style scoped>
.topic-bar{
  width: 100%;
  height: 265px;
  background-color: #fff;
  border-bottom: 1px solid #eee;
  cursor: pointer;
  color: #666;
}
.topic-bar:hover{
 background-color:#eeefff;
}

.topic-title{
  font-size: 16px;
  font-weight: bold;
  color: #000;
  padding-left: 10px;
  line-height: 35px;
  height: 35px;
}
.topic-summary{
  font-size: 12px;
  color: #666;
  padding-left: 10px;
  height: 15px;
}
.topic-content{
  position: relative;
  height: 120px;
  margin: 5px 10px;
  overflow: hidden;
}
.topic-foot{
  padding-left: 10px;
  color: #666;
  font-size:12px;
}
.topic-foot img{
  cursor: pointer;
}
.topic-foot span{
  padding-left: 5px;
  padding-right: 20px;
}
.btn-copy{
  position: relative;
  border-radius: 5px;
  width: 18px;
  height: 18px;
  left: calc(100% - 20px);
  top: 3px;
  z-index: 4;
}
.btn-copy:hover{
  background-color: #666;
}
.icon-copy{
  width: 18px;
  height: 18px;
}
.copy-status{
  display: none;
}
</style>
